import { SET_LOADING_NOTIF, GET_NOTIFS, GET_NOTIF_ITEM, ERROR_NOTIF } from '../types';

const initialState = {
  notifs: null,
  count: null,
  notSeenCount: null,
  seenCount: null,
  isLoading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFS:
      let { results, count } = action.payload;
      return {
        ...state,
        notifs: results,
        count,
        notSeenCount: action.payload.results.filter(item => item.seen === false).length,
        seenCount: action.payload.results.filter(item => item.seen === true).length,
        isLoading: false,
      };

    case SET_LOADING_NOTIF:
      return {
        ...state,
        isLoading: true,
      };

    case GET_NOTIF_ITEM:
      return {
        ...state,
        notifs: state.notifs.map(notif => {
          if (notif.id === action.payload.id) {
            notif.seen = true;
          }
          return notif;
        }),
        notSeenCount: state.notSeenCount - 1,
        seenCount: state.seenCount + 1,
        isLoading: false,
      };

    case ERROR_NOTIF:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};
